export default __webpack_public_path__ + "static/media/aion.a2d067b3.svg";